var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 102C42.675 102 42 101.193 42 100.206V69.7942C42 68.8074 42.675 68 43.5 68C44.325 68 45 68.8074 45 69.7942V100.206C45 101.193 44.325 102 43.5 102Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 91C59.9 91 59 90.2008 59 89.2239V69.7761C59 68.7992 59.9 68 61 68C62.1 68 63 68.7992 63 69.7761V89.2239C63 90.2008 62.1 91 61 91Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7293 69H28.3594C22.0585 69 17 64.0125 17 57.8875V28.75C17 27.7875 17.7987 27 18.7749 27H86.2251C87.2013 27 88 27.7875 88 28.75V57.8875C88 64.0125 82.9415 69 76.7293 69ZM20.5498 30.5V57.8875C20.5498 62.0875 24.0109 65.5875 28.3594 65.5875H76.7293C80.9891 65.5875 84.5389 62.175 84.5389 57.8875V30.5H20.5498Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.25 30H64.75C63.7875 30 63 29.2125 63 28.25V8.9125C63 5.15 66.15 2 69.9125 2C73.85 2 77 5.15 77 8.9125V28.25C77 29.2125 76.2125 30 75.25 30ZM66.5 26.5H73.5V8.9125C73.5 7.075 71.925 5.5 70.0875 5.5C68.075 5.5 66.5 7.075 66.5 8.9125V26.5Z",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 30H30.75C29.7875 30 29 29.2125 29 28.25V8.9125C29 5.15 32.15 2 35.9125 2C39.85 2 43 5.15 43 8.9125V28.25C43 29.2125 42.2125 30 41.25 30ZM32.5 26.5H39.5V8.9125C39.5 7.075 37.925 5.5 36.0875 5.5C34.075 5.5 32.5 7.075 32.5 8.9125V26.5Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.ec58d75be1976eb20659c8b23cf738be.svg";
export { ForwardRef as ReactComponent };